import Avatar from './Avatar'
export default Avatar



// WEBPACK FOOTER //
// ./src/atoms/Avatar/index.js